import { getLocalizedValue, getAttrValue } from '@grandvisionhq/utils';
import { getLineItemImageUrl } from './get-line-item-image-url.js';
import { getProductTag } from './get-product-tag.js';
import { getPrice } from './legacy-get-price.js';

/**
 * From the API returned upsell data, create objects that can be processed
 * by the Upsell components
 */ const parseCTUpsellData = (upsellProducts, locale, staticsUrl, getLabel, isBynderImagesEnabled, isProductLabelEnabled)=>{
    if (!upsellProducts || upsellProducts.length === 0) {
        return [];
    }
    return upsellProducts.reduce((storedUpsellProducts, solution, index)=>{
        var ref;
        const { masterVariant , name  } = solution;
        const price = getPrice(masterVariant.prices);
        if (price === undefined || index > 3) {
            return storedUpsellProducts;
        }
        const title = getLocalizedValue(name, locale);
        var _sku;
        const sku = (_sku = masterVariant.sku) !== null && _sku !== void 0 ? _sku : '';
        const imageUrl = getLineItemImageUrl(masterVariant, staticsUrl, isBynderImagesEnabled);
        const solutionType = getAttrValue(masterVariant, 'solutionType');
        const volume = getAttrValue(masterVariant, 'volume');
        const tag = !isProductLabelEnabled ? getProductTag((ref = masterVariant.tags) === null || ref === void 0 ? void 0 : ref[0], locale) : undefined;
        const availability = masterVariant.availability;
        const channelsMap = (availability === null || availability === void 0 ? void 0 : availability.channels) ? Object.entries(availability.channels) : [];
        const hasAvailableQuantity = channelsMap.some(([, channel])=>channel.availableQuantity
        );
        // When no availablity on product variant this item should still be orderable
        const isAvailable = !availability ? true : hasAvailableQuantity;
        if (!isAvailable) {
            return storedUpsellProducts;
        }
        let body;
        if (solutionType && volume) {
            body = `${solutionType}, ${volume}${getLabel('products.unit.metric.liter.milli.abbr')}`;
        }
        const product = {
            title,
            body,
            imageUrl,
            sku,
            price,
            tag
        };
        return [
            ...storedUpsellProducts,
            product
        ];
    }, []);
};

export { parseCTUpsellData };
//# sourceMappingURL=parse-ct-upsell-data.js.map
